/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/prop-types */
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import { TableListContextProps } from './TableListContext.types';
import { TableListProviderProps } from './TableListProvider.types';

const TableListContext = createContext<TableListContextProps>(undefined!);
export function useTableList() {
  return useContext(TableListContext);
}

export function TableListProvider({ children, tableMetadata }: TableListProviderProps) {
  const [data, setData] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>();
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState<number | undefined>();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [disablePagination, setDisablePagination] = useState(false);
  const [loading, setLoading] = useState<Map<string, boolean>>();
  const [selected, setSelected] = useState<Map<string, boolean>>();

  useEffect(() => {
    if (data) {
      const filteredData = data.filter((value) => {
        if (tableMetadata && searchTerm) {
          let found = false;
          if (tableMetadata.cells) {
            tableMetadata.cells.forEach((cell) => {
              let val = '';
              if (cell.value) {
                val = cell.value(value);
              } else if (cell.key) {
                val = `${value[cell.key]}`;
              }
              if (val && val.toLowerCase().includes(searchTerm.toLowerCase())) {
                found = true;
              }
            });
          }
          if (tableMetadata.primary) {
            if (tableMetadata.primary(value).toLowerCase().includes(searchTerm.toLowerCase())) {
              found = true;
            }
          }
          if (tableMetadata.secondary) {
            if (tableMetadata.secondary(value).toLowerCase().includes(searchTerm.toLowerCase())) {
              found = true;
            }
          }
          return found;
        }
        return true;
      });

      if (disablePagination !== true) {
        setNumPages(Math.ceil(filteredData.length / rowsPerPage));
        setTableData(
          filteredData.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage),
        );
      } else {
        setNumPages(undefined);
        setTableData(filteredData);
      }
    } else {
      setTableData([]);
    }
  }, [
    data,
    page,
    searchTerm,
    tableMetadata,
    disablePagination,
    rowsPerPage,
  ]);

  // const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <TableListContext.Provider
      value={{
        page,
        numPages,
        tableData,
        searchTerm,
        tableMetadata,
        loading,
        selected,
        setLoading,
        setSelected,
        setData,
        setDisablePagination,
        setPage,
        setRowsPerPage,
        setSearchTerm,
      }}
    >
      {children}
    </TableListContext.Provider>
  );
}
